module.exports = __webpack_public_path__ + "img/ban02.85679e7.png";